<template>
  <Teleport to="body">
    <Transition name="clear-confirm-fade">
      <div
        v-if="modelValue"
        class="clear-confirm"
        role="dialog"
        aria-modal="true"
        @click.self="onCancel"
      >
        <div class="clear-confirm__card">
          <div class="clear-confirm__icon">
            <UIcon name="i-heroicons-trash" class="w-7 h-7" />
          </div>

          <h3 class="clear-confirm__title">Очистить корзину?</h3>
          <p class="clear-confirm__text">
            Вы точно хотите очистить корзину? Все товары будут удалены.
          </p>

          <div class="clear-confirm__actions">
            <UiKitButton color="default" variant="flat" full-width @click="onCancel">
              Отмена
            </UiKitButton>
            <!-- :accent="false" — здесь красный означает «опасно», а не бренд -->
            <UiButtonMain color="red" :accent="false" size="lg" block label="Очистить" @click="onConfirm" />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useScrollLock } from '@shared/lib'

const props = defineProps<{ modelValue: boolean }>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'confirm'): void
}>()

// Пока диалог открыт — фон не скроллится и не «прыгает».
useScrollLock(() => props.modelValue)

function onCancel(): void {
  emit('update:modelValue', false)
}

function onConfirm(): void {
  emit('confirm')
  emit('update:modelValue', false)
}
</script>

<style scoped lang="scss">
.clear-confirm {
  @apply fixed inset-0 z-[100] flex items-center justify-center p-4;
  @apply bg-black/60 backdrop-blur-sm;

  &__card {
    @apply w-full max-w-sm flex flex-col items-center text-center gap-3 p-6;
    @apply bg-hui-content1 rounded-hui-lg border border-hui-divider shadow-2xl;
  }

  &__icon {
    @apply flex items-center justify-center w-14 h-14 rounded-full;
    @apply bg-red-500/10 text-red-500;
  }

  &__title {
    @apply text-lg font-bold text-hui-foreground;
  }

  &__text {
    @apply text-sm text-hui-foreground/60;
  }

  &__actions {
    @apply grid grid-cols-2 gap-2 w-full mt-2;
  }
}

.clear-confirm-fade-enter-active,
.clear-confirm-fade-leave-active {
  transition: opacity 0.2s ease;
}

.clear-confirm-fade-enter-from,
.clear-confirm-fade-leave-to {
  opacity: 0;
}
</style>
